import React from 'react';
import { FormattedMessage } from 'react-intl';

import LoadingIndicator from '@swf/components/LoadingIndicator/LoadingIndicator';

import { TXTCLI_LoadingXX_Please_wait } from './Initialize.messages.json';
import styles from './Initialize.scss';

const Initialize: React.FC = () => (
  <div className={styles.initialize}>
    <FormattedMessage tagName="p" {...TXTCLI_LoadingXX_Please_wait} />
    <LoadingIndicator loading />
  </div>
);

export default Initialize;
